import CONSTANTS from "../Constants/ApiConstants";

function _getNumberToCurrency(price = "0", isNumber = false, isRemoveDecimal = false) {
    const newPrice = parseFloat(price || "0")
    return Intl.NumberFormat('en-IN', (isNumber ? {} : {
        style: 'currency',
        currency: 'INR',
        ...isRemoveDecimal && {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }
    })).format(newPrice)

}

const _capitalize = (sentence) => {
    return sentence.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

function getBase64(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.addEventListener('load', async () => { return resolve(reader.result); });
        reader.addEventListener('error', async () => { return reject(); });
    })
}


function getFileMimeTypeOnExtension(acceptFileType = ['jpg', 'jpeg', 'png']) {
    let fileMimeType = [];

    acceptFileType.map((extDetails) => {
        if (!!CONSTANTS?.EXTENSION_MIME_TYPE?.[extDetails]) {
            fileMimeType.push(CONSTANTS.EXTENSION_MIME_TYPE[extDetails]);
        }
        return extDetails;
    });

    return fileMimeType;
}

function getFullName({ first_name = "", last_name = "" } = {}) {
    let fullName = "";
    if (!!first_name) {
        fullName = first_name
    }
    if (!!last_name) {
        fullName += ((!!fullName ? " " : "") + last_name);
    }
    return fullName;
}

export { _getNumberToCurrency, getFullName, getFileMimeTypeOnExtension, getBase64, };